import React from 'react'

// style
import { Container } from './style'

// functions
import { stripSlashes } from '~/services/functions'

const Question = ({ dataQuestion, answersComponent, hideNumbering }) => {

  const conteudoOriginal = stripSlashes(dataQuestion.questao);

  const conteudoLimpo = conteudoOriginal
    .replace(/<div/g, '<span')
    .replace(/<\/div>/g, '</span>')
    .replace(/<p/g, '<span') 
    .replace(/<\/p>/g, '</span>');

  return (
    <Container answeredQuestion={dataQuestion.answered !== undefined ? dataQuestion.answered : true} hideNumbering={hideNumbering}>
      <h4>
        <span dangerouslySetInnerHTML={{ __html: conteudoLimpo }} />
      </h4>
      <span className="wrap-answers">
        {answersComponent}
      </span>
    </Container>
  )
}
export default Question